"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeManager = void 0;
var makeCssVariableDefinitionsMap_1 = require("./lib/makeCssVariableDefinitionsMap");
/**
 * Use this class to set and apply themes, and to access or subscribe to the currently active one.
 * This class fulfills the idea of theming and runtime theme switching by relying on CSS variables,
 * and the ability to update them in JavaScript - a framework agnostic method.
 *
 * It works by converting a Theme interface to a flattened map of CSS variable keys and values, then calling `document.documentElement.style.setProperty(key, value)`.
 */
var ThemeManager = /** @class */ (function () {
    function ThemeManager(theme, rootElementId, 
    /* This allows you to stop the  class from applying the theme automatically during construction. Defaults to true */
    apply) {
        if (rootElementId === void 0) { rootElementId = ""; }
        if (apply === void 0) { apply = true; }
        var _this = this;
        this.themeChangeListeners = [];
        this.rootElement = null;
        this.getRootElement = function () { return _this.rootElement; };
        this.getRootElementId = function () { return _this.rootElementId; };
        this.getCurrentTheme = function () { return _this.theme; };
        this.setRootElement = function (element) {
            _this.rootElement = element;
        };
        this.setRootElementId = function (rootElementId) {
            return (_this.rootElementId = rootElementId);
        };
        this.setAndApplyTheme = function (theme, force) {
            if (!force) {
                if (_this.theme === theme)
                    return;
            }
            _this.theme = theme;
            _this.applyCurrentTheme();
            _this.notifyThemeChangeListeners(theme);
        };
        this.addThemeChangeListener = function (listener) {
            _this.themeChangeListeners.push(listener);
        };
        this.removeThemeChangeListener = function (listener) {
            _this.themeChangeListeners = _this.themeChangeListeners.filter(function (l) { return l !== listener; });
        };
        this.applyCurrentTheme = function () {
            var _a;
            if (typeof window !== "undefined") {
                _this.setRootElement((_a = document.getElementById(_this.rootElementId)) !== null && _a !== void 0 ? _a : document.documentElement);
                var cssVariableDefinitions = (0, makeCssVariableDefinitionsMap_1.makeCssVariableDefinitionsMap)(_this.theme);
                Object.entries(cssVariableDefinitions).forEach(function (_a) {
                    var _b;
                    var key = _a[0], value = _a[1];
                    (_b = _this.rootElement) === null || _b === void 0 ? void 0 : _b.style.setProperty(key, value);
                });
            }
        };
        this.notifyThemeChangeListeners = function (theme) {
            _this.themeChangeListeners.forEach(function (listener) { return listener(theme); });
        };
        /*
          For some reason, storybook likes this way of defining class properties better.
          If you use `constructor( private theme: Theme, ...)` - theme becomes undefined within the class's methods.
        */
        this.theme = theme;
        this.rootElementId = rootElementId;
        if (apply)
            this.applyCurrentTheme();
    }
    return ThemeManager;
}());
exports.ThemeManager = ThemeManager;
// I would like to expose this, but instantiating ThemeManager in some situations or runtimes (such as nodejs) cause exceptions.
// For now it is not exposed, but we might come back to it, as it makes sense to have a singleton ThemeManager in almost all cases
/* export const defaultThemeManager = new ThemeManager(defaultTheme) */
//# sourceMappingURL=ThemeManager.js.map